<rk-mobile-close-button class="fixed z-10" (click)="exitPanel()"></rk-mobile-close-button>
<div class="flex items-baseline gap-1">
  <rk-page-title
    class="pl-5"
    [class.-mb-4]="$step() === 2"
    [title]="
      this.$isEditing()
        ? ('PLAYLIST.CREATE_FORM.EDIT_TITLE' | translate)
        : ('PLAYLIST.CREATE_FORM.TITLE' | translate)
    "
  ></rk-page-title>
  @if ($totalSteps() > 1) {
    <div class="text-gray-darkest">{{ $step() }}/{{ $totalSteps() }}</div>
  }
</div>
<form
  *ngIf="createPlaylistForm"
  class="flex flex-col flex-1"
  [class]="$step() === 2 ? 'pb-12' : 'pb-20'"
  (ngSubmit)="submit()"
  [formGroup]="createPlaylistForm"
  novalidate
>
  <mat-stepper linear class="flex-1 -mx-5 -mb-5 no-header full-height" #stepper>
    <mat-step class="flex flex-col flex-1">
      <div class="step">
        <div class="form-fields px-5">
          <div>
            <rk-form-field
              [label]="'PLAYLIST.CREATE_FORM.NAME' | translate"
              [hideCharLimit]="true"
            >
              <input
                data-cy="create-playlist-name"
                type="text"
                rkInput
                formControlName="name"
                maxlength="150"
                required
              />
              <rk-form-error
                *ngIf="createPlaylistFormErrors.name.required"
                [errorMessage]="'PLAYLIST.CREATE_FORM.TITLE_REQUIRED' | translate"
              ></rk-form-error>
            </rk-form-field>
            <rk-form-field [label]="'PLAYLIST.CREATE_FORM.COLOR' | translate">
              <rk-input-color-picker
                [showWhite]="false"
                formControlName="color"
              ></rk-input-color-picker>
            </rk-form-field>
          </div>
        </div>

        @if (!$isEditing()) {
          <div class="playlist-type px-5 pt-5 bg-white">
            <div class="section-title" translate>PLAYLIST.CREATE_FORM.SETTINGS</div>
            <rk-form-field>
              <mat-radio-group rkInput formControlName="type">
                <mat-radio-button data-cy="radio-button-manual-playlist" value="manual">{{
                  'PLAYLIST.CREATE_FORM.PLAYLIST_MANUAL' | translate
                }}</mat-radio-button>
                <span class="hint" translate>PLAYLIST.CREATE_FORM.HINT_MANUAL</span>
                <mat-radio-button
                  data-cy="radio-button-dynamic-playlist"
                  value="dynamic"
                  >{{
                    'PLAYLIST.CREATE_FORM.PLAYLIST_AUTO' | translate
                  }}</mat-radio-button
                >
                <span class="hint" translate>PLAYLIST.CREATE_FORM.HINT_AUTO</span>
              </mat-radio-group>
            </rk-form-field>
          </div>
        }
      </div>
    </mat-step>
    <mat-step
      *ngIf="createPlaylistForm.get('type').value === 'dynamic'"
      class="flex flex-col flex-1"
    >
      <div class="step">
        <div *ngIf="$step() === 2" translate class="pl-5 mb-4 text-gray text-base">
          MEDIA.MODAL.ADD_PLAYLIST.AUTOMATIC
        </div>
        <div class="criteria-step p-5 flex-1 bg-white">
          <div class="criteria-title" translate>PLAYLIST.CREATE_FORM.CRITERIA_TITLE</div>
          <div class="criteria-hint" translate>PLAYLIST.CREATE_FORM.CRITERIA_HINT</div>
          <div *ngIf="getCriteriaLength()" formArrayName="criteria" class="mb-20">
            <div
              *ngFor="let criterion of criteria.controls; let i = index"
              class="criteria"
            >
              <div [ngSwitch]="getCriteriaType(criterion.value.field)">
                <rk-playlist-criteria-text
                  *ngSwitchCase="'text'"
                  [title]="getCriteriaTitle(criterion.value.field)"
                  [formControlName]="i"
                  [data]="getCriteriaTextSuggestion(criterion.value.field)"
                  (deleteCriteria)="removeCriteria($event)"
                  [submitEvent$]="submitSubject.asObservable()"
                ></rk-playlist-criteria-text>
                <rk-playlist-criteria-number
                  *ngSwitchCase="'number'"
                  [title]="getCriteriaTitle(criterion.value.field)"
                  [formControlName]="i"
                  (deleteCriteria)="removeCriteria($event)"
                  [submitEvent$]="submitSubject.asObservable()"
                ></rk-playlist-criteria-number>
                <rk-playlist-criteria-box
                  *ngSwitchCase="'box'"
                  [title]="getCriteriaTitle(criterion.value.field)"
                  [formControlName]="i"
                  (deleteCriteria)="removeCriteria($event)"
                  [submitEvent$]="submitSubject.asObservable()"
                ></rk-playlist-criteria-box>
                <rk-playlist-criteria-tag
                  *ngSwitchCase="'tags'"
                  [title]="getCriteriaTitle(criterion.value.field)"
                  [formControlName]="i"
                  (deleteCriteria)="removeCriteria($event)"
                  [submitEvent$]="submitSubject.asObservable()"
                ></rk-playlist-criteria-tag>
                <rk-playlist-criteria-date
                  *ngSwitchCase="'date'"
                  [title]="getCriteriaTitle(criterion.value.field)"
                  [formControlName]="i"
                  (deleteCriteria)="removeCriteria($event)"
                  [submitEvent$]="submitSubject.asObservable()"
                ></rk-playlist-criteria-date>
              </div>
            </div>
          </div>
          <rk-button
            [label]="'PLAYLIST.CREATE_FORM.ADD_CRITERIA' | translate"
            [matMenuTriggerFor]="criteriaMenu"
            [fullWidth]="true"
            btnStyle="flat"
            class="add-criteria-button w-full"
          ></rk-button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
  <rk-footer-actions
    [cancelText]="
      $step() === 1 ? ('MODAL.DEFAULT.CANCEL' | translate) : ('GLOBAL.PREV' | translate)
    "
    [submitText]="
      $totalSteps() === 2 && $step() === 1
        ? ('SLIDESHOW.NEXT' | translate)
        : this.$isEditing()
          ? ('GLOBAL.SAVE' | translate)
          : ('GLOBAL.ADD' | translate)
    "
    [disabledSubmit]="
      !createPlaylistForm || !createPlaylistForm.get('name').valid || (isSaving$ | async)
    "
    (cancelled)="$step() === 2 ? prevStep() : exitPanel()"
    (submitted)="$totalSteps() === 2 && $step() === 1 ? nextStep() : submit()"
  ></rk-footer-actions>
</form>
<mat-menu #criteriaMenu="matMenu" class="mob-criteria-mat-menu">
  <div mat-menu-item (click)="addCriteria('idtrackbox')">
    <mat-icon fontSet="fa" fontIcon="fa-inbox"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.BOX</span>
  </div>
  <div mat-menu-item (click)="addCriteria('artist')">
    <mat-icon fontSet="fa" fontIcon="fa-user"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.ARTIST</span>
  </div>
  <div mat-menu-item (click)="addCriteria('title')">
    <mat-icon fontSet="fa" fontIcon="fa-microphone"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.TITLE</span>
  </div>
  <div mat-menu-item (click)="addCriteria('album')">
    <mat-icon fontSet="fa" fontIcon="fa-image"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.ALBUM</span>
  </div>
  <div mat-menu-item (click)="addCriteria('year')">
    <mat-icon fontSet="fa" fontIcon="fa-calendar-alt"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.YEAR</span>
  </div>
  <div mat-menu-item (click)="addCriteria('bpm')">
    <mat-icon fontSet="fa" fontIcon="fa-poll"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.BPM</span>
  </div>
  <div mat-menu-item (click)="addCriteria('playtime_seconds')">
    <mat-icon fontSet="fa" fontIcon="fa-clock"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.DURATION</span>
  </div>
  <div mat-menu-item (click)="addCriteria('upload_date')">
    <mat-icon fontSet="fa" fontIcon="fa-calendar-plus"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.UPLOAD_DATE</span>
  </div>
  <div mat-menu-item (click)="addCriteria('tags')">
    <mat-icon fontSet="fa" fontIcon="fa-tag"></mat-icon>
    <span translate>PLAYLIST.CRITERIA.TAG</span>
  </div>
</mat-menu>
